import clsx from 'clsx';
import React, { useLayoutEffect, useState } from 'react';

import { getConfigProperty } from '@/common/oldMobile';
import IntersectionObserver from '@/ui/IntersectionObserver';
import useLandscape from 'nike-ui/src/hooks/useLandscape';

function getCasinoGameImageUrl(cmdGameId: string) {
    return `${getConfigProperty('casino.image.link.url')}mobile/${cmdGameId}`;
}

function CasinoGameImg({
    gameId,
    className,
    alt = '',
    onClick,
    detail,
    headerHeight
}: {
    gameId: string;
    alt: string;
    className?: string;
    onClick?: () => any;
    detail?: boolean;
    headerHeight?: number;
}) {
    const [measuredHeight, setMeasuredHeight] = useState(headerHeight);
    //useLandscape to detect landscape changes - avoid using resize - causes increasing/decreasing size of image in detail
    //when refreshing page by swiping down
    const landscape = useLandscape();
    useLayoutEffect(() => {
        function resizeByHeight() {
            //(mainTabBar - 60px, responsible gaming - 20px, button 56px + 14px margin) = 160px, headerHeight can be different based on jackpots
            setMeasuredHeight(window.innerHeight - headerHeight - 160);
        }
        if (detail) {
            resizeByHeight();
        }
    }, [detail, landscape, headerHeight]);
    return (
        <IntersectionObserver>
            {visible => (
                <div
                    className={clsx({ 'casino-game-item-img casino-game-img': !detail }, className)}
                    onClick={onClick}
                    style={{ maxHeight: measuredHeight }}
                >
                    {visible ? (
                        <img
                            loading="lazy"
                            src={`${getCasinoGameImageUrl(gameId)}`}
                            alt={alt}
                            style={{ maxHeight: measuredHeight }}
                        />
                    ) : (
                        <div style={{ position: 'absolute', top: 0 }} />
                    )}
                </div>
            )}
        </IntersectionObserver>
    );
}

export default CasinoGameImg;
